import type { AccordionItem } from "./Accordion";
import { PHONE_DISPLAY, PHONE_HREF } from "./primitives";

export const HOME_FAQ: AccordionItem[] = [
  {
    q: "What's the difference between spray foam, blown, and batting insulation?",
    a: "Spray foam expands to seal air leaks as well as insulate. Blown insulation is a fast, economical way to build depth in attics, and batting is a budget-friendly fit in standard framed cavities. Gary will tell you plainly which one earns its cost in your building.",
  },
  {
    q: "Is spray foam worth the cost?",
    a: "In most Wisconsin buildings, yes — because it stops air movement, not just heat transfer. That means steadier rooms and less strain on heating and cooling. Gary will tell you if it's the right spend for your building.",
  },
  {
    q: "How does the price match work?",
    a: "Get a competitor's spray foam bid, show us proof of bid, and we'll meet or beat it. It applies to spray foam services only, and you still get 25+ years of expertise on the job.",
  },
  {
    q: "Do you work on new construction?",
    a: "New construction spray foam is our flagship. We coordinate with builders and general contractors to hit framing and drywall schedules so nobody is waiting on insulation.",
  },
  {
    q: "What areas do you serve?",
    a: (
      <>
        We&rsquo;re based in Prairie Farm, WI and serve Northwest Wisconsin. If you&rsquo;re not
        sure whether you&rsquo;re in range,{" "}
        <a href={PHONE_HREF} className="font-bold text-foam-deep">
          give us a call
        </a>{" "}
        and we&rsquo;ll tell you straight.
      </>
    ),
  },
  {
    q: "How do I get a quote?",
    a: (
      <>
        Call{" "}
        <a href={PHONE_HREF} className="font-bold text-foam-deep">
          {PHONE_DISPLAY}
        </a>{" "}
        or fill out the{" "}
        <a href="/contact" className="font-bold text-foam-deep">
          quote form
        </a>{" "}
        with a little about your project. We&rsquo;ll follow up, talk through your options, and get
        you a clear number.
      </>
    ),
  },
];
